export const FETCH_EMAIL_REQUEST = 'FETCH_EMAIL_REQUEST';
export const FETCH_EMAIL_SUCCESS = 'FETCH_EMAIL_SUCCESS';
export const FETCH_EMAIL_FAILURE = 'FETCH_EMAIL_FAILURE';
export const CHANGE_EMAIL_FETCHED_STATE = 'CHANGE_EMAIL_FETCHED_STATE';
